export const GLOBAL_PASSWORD_LABELS = 'global.password';
export const lblUserNotAvailable = 'lbl_forgotPassword_userNotAvailable';
export const lblForgotPwdContent1 = 'lbl_forgotPassword_content1';
export const lblForgotPwdSecHeader = 'lbl_forgotPassword_page_secondary_header';
export const lblForgotPwdNextBtn = 'lbl_forgotPassword_page_next_btn';
export const lblDontHavePhone = 'lbl_dont_have_phone';
export const lblSendCodeViaEmail = 'lbl_send_code_via_email_address';
export const lblForgotPwdBackLogin = 'lbl_forgotPassword_backLogin';
export const lblforgotPwdContent2 = 'lbl_forgotPassword_content2';
export const lblforgotPwdContent3 = 'lbl_forgotPassword_content3';
export const lblForgotPwdReset = 'lbl_forgotPassword_resetPassword';
export const lblForgotPwdReturnLogin = 'lbl_forgotPassword_returnLogin';
export const lblForgotPwdCheckMail = 'lbl_forgotPassword_checkMail';
export const lblresetPwdContent1 = 'lbl_resetPassword_content1';
export const lblSmsConsent = 'lbl_sms_consent';
export const lblResetPwdRequestCode = 'lbl_resetPassword_request_verification_code';
export const lblChangePwdSuccess = 'lbl_changePassword_successMessage';
export const lblSendCodeViaEmailInstead = 'lbl_send_code_via_email_instead';
export const lblPasswordSendCodeViaEmail = 'lbl_send_code_via_email';
export const lblLoginToCheckoutCtaPlcc = 'lbl_changePassword_loginToCheckoutCta_PLCC';
export const lblVerifyOtp = 'lbl_verify_otp';
export const lblResendIt = 'lbl_resend_it';
export const lblPhoneOtpNotReceived = 'lbl_phone_otp_not_received_content';
export const lblDidntReceiveOtpPhone = 'lbl_didnt_receive_otp_sent_to_phone';
export const lblSendCodeViaPhone = 'lbl_send_code_via_phone';
export const lblResetPwdCodeSent = 'lbl_resetPassword_new_code_sent';
export const lblCustomerService = 'lbl_customer_service';
export const lblResetPwdPageHeading = 'lbl_resetPassword_page_heading';
export const lblResetPwdEmailSubHeading = 'lbl_resetPassword_email_sub_heading';
export const lblResetPwdEmailReceived = 'lbl_resetPassword_email_received';
export const lblResetPwdCheckJunkEmail = 'lbl_resetPassword_check_junk_email';
export const lblResetPasswordResetCta = 'lbl_resetPassword_resetCta';
export const lblResetPwdConfirmPwd = 'lbl_resetPassword_confirmPassword';
export const lblResetPassword = 'lbl_resetPassword_password';
export const lblResetPwdResendCode = 'lbl_resetPassword_resend_code';
export const lblResetPwdSuccessMsg = 'lbl_resetPassword_successMessage';
export const lblChangePwdHide = 'lbl_changePassword_hide';
export const lblChangePwdShow = 'lbl_changePassword_show';
export const lblResetPwdPageCheckCode = 'lbl_resetPassword_page_check_code';
export const lblResetPwdPageCheckCodePhone = 'lbl_resetPassword_page_check_code_phone';
export const lblResetPwdBackLogin = 'lbl_resetPassword_backLogin';
export const lblResetPwdHeading = 'lbl_resetPassword_heading';
export const lblResetPwdOtpSentPhone = 'lbl_resetPassword_otp_sent_to_phone';
export const lblResetPwdEnterCode = 'lbl_resetPassword_page_enter_code';
export const lblCodeSubHeaderMsg = 'lbl_code_sub_header_msg';
export const lblConfirmCodeMsg = 'lbl_confirm_code_msg';
export const lblChangePwdHeading = 'lbl_changePassword_heading';
export const lblCurrentPwd = 'lbl_changePassword_current_password';
export const lblNewPwd = 'lbl_changePassword_new_password';
export const lblEnterPwd = 'lbl_changePassword_enter_password_PLCC';
export const lblSaveCta = 'lbl_changePassword_saveCta';
export const lblConfirmPwd = 'lbl_changePassword_confirm_password';
export const lblLoginCtaPlcc = 'lbl_changePassword_loginCta_PLCC';
export const lblSaveAndCheckoutCta = 'lbl_changePassword_saveAndCheckoutCta_PLCC';
export const lblSaveCtaPlcc = 'lbl_changePassword_saveCta_PLCC';
export const lblInputSuccess = 'lbl_changePassword_input_success';
export const lblrequirementTip1 = 'lbl_resetPassword_requirementTips1';
export const lblrequirementTip2 = 'lbl_resetPassword_requirementTips2';
export const lblrequirementTip3 = 'lbl_resetPassword_requirementTips3';
export const lblrequirementTip4 = 'lbl_resetPassword_requirementTips4';
export const lblrequirementTip5 = 'lbl_resetPassword_requirementTips5';
export const lblrequirementTip6 = 'lbl_reserPassword_requirementTips6';
export const lblRequirementHeading = 'lbl_resetPassword_requirementHeading';
export const lblInvalidCurrentPwd = 'lbl_changePassword_INVALID_CURRENT_PASSWORD';
export const lblPasswordInfo = 'lbl_changePassword_password_info';
export const lblResetPwdCheckRecaptcha = 'lbl_resetPassword_check_recaptcha';
export const lblRequirementNote = 'lbl_resetPassword_requirementNote';
export const lblGenericError = 'lbl_resetPassword_genericError';
export const lblLinkExpired = 'lbl_resetPassword__TCP_RESET_PASSWORD_LINK_EXPIRED';
export const lblReuseOldPassword = 'lbl_resetPassword__ERR_AUTHENTICATION_REUSEOLD_PASSWORD';
export const lblDuplicateRecaptcha = 'lbl_resetPassword_DUPLICATE_RECAPTCHA_TOKEN';
export const lblPagwHeadingSec = 'lbl_resetPassword_page_heading_secondary';
export const lblPwdCodeInvalid = 'lbl_resetPassword__TCP_RESET_PASSWORD_CODE_INVALID';
export const lblPwdCodeExpired = 'lbl_resetPassword__TCP_RESET_PASSWORD_CODE_EXPIRED';
export const lblRecaptchaNotCalled = 'lbl_resetPassword__TCP_RESET_PASSWORD_RECAPTCHA_NOT_CALLED';
export const lblPwdAccountLocked = 'lbl_resetPassword__TCP_RESET_PASSWORD_ACCOUNT_LOCKED';
export const lblRecaptchaFailed = 'lbl_resetPassword__RECAPTCHA_FAILED';
export const lblMinLengthPwd =
  'lbl_resetPassword__ERR_AUTHENTICATION_SPECIALCHAR_MINIMUMLENGTH_PASSWORD';

export const GlobalPasswordsLabels = {
  global: {
    password: {
      [lblMinLengthPwd]:
        'Please enter a valid special character from the list provided !@#$%^&*()_?.-',
      [lblRecaptchaFailed]: 'Error verifying reCAPTCHA. Please try again',
      [lblPwdAccountLocked]:
        'For your security, your account has been locked. Please contact customer service at 1-877-752-2387 to unlock your account.',
      [lblRecaptchaNotCalled]: 'Error verifying reCAPTCHA. Please try again',
      [lblPwdCodeExpired]: 'Passcode expired. Click "Resend it" for a new passcode.',
      [lblPwdCodeInvalid]:
        'This code is invalid. Please check the code and try again or click "Resend Code" for a new code.',
      [lblPagwHeadingSec]:
        "Didn't get your email? Wait a few more minutes, check your spam folder or contact Customer Service.",
      [lblDuplicateRecaptcha]:
        'This password was used recently; please create a new one following the password requirements.',
      [lblReuseOldPassword]:
        'This password was used recently; please create a new one following the password requirements.',
      [lblLinkExpired]:
        'This password reset link has expired. Please click here to request a new password reset.',
      [lblGenericError]:
        'Your password has not been updated. Please check the password requirements and try again.',
      [lblRequirementNote]: 'Note: It cannot be your email address or a recently used password.',
      [lblUserNotAvailable]:
        'We couldn’t find an account associated with that email address; check the spelling and try again.',
      [lblForgotPwdContent1]: 'Forgot your password?',
      [lblForgotPwdSecHeader]: 'Enter your registered email address.',
      [lblForgotPwdNextBtn]: 'Next',
      [lblDontHavePhone]: 'Don’t have access to your phone?',
      [lblSendCodeViaEmail]: 'Send code via Email Address',
      [lblForgotPwdBackLogin]: ' Back to Log In',
      [lblforgotPwdContent3]: 'No worries!',
      [lblforgotPwdContent2]:
        'Enter your registered email address, and we’ll send instructions to reset your password.',
      [lblForgotPwdReset]: 'Reset Password',
      [lblForgotPwdReturnLogin]: ' Return to Log In',
      [lblForgotPwdCheckMail]: 'Check Your Email',
      [lblresetPwdContent1]: 'Select how you would like to receive password reset',
      [lblSmsConsent]:
        'By selecting this box, you agree to standard text messaging rates will apply.',
      [lblResetPwdRequestCode]: 'REQUEST VERIFICATION CODE',
      [lblChangePwdSuccess]: 'Your password has been updated!',
      [lblSendCodeViaEmailInstead]: 'Send code via Email instead',
      [lblPasswordSendCodeViaEmail]: 'Send code via Email',
      [lblLoginToCheckoutCtaPlcc]: 'LOGIN TO CHECKOUT',
      [lblVerifyOtp]: 'Verify one-time passcode',
      [lblResendIt]: 'Resend it.',
      [lblPhoneOtpNotReceived]: 'Still haven’t received the passcode?',
      [lblDidntReceiveOtpPhone]: 'Didn’t receive code?',
      [lblSendCodeViaPhone]: 'Send code via Phone Number',
      [lblResetPwdCodeSent]: 'New passcode sent!',
      [lblCustomerService]: 'Customer Service',
      [lblResetPwdPageHeading]: 'Verification code sent to',
      [lblResetPwdEmailSubHeading]:
        "Didn't get an email? Wait a few more minutes, check your spam folder or contact ",
      [lblResetPwdEmailReceived]: "Didn't receive the email? It may take a few minutes",
      [lblResetPwdCheckJunkEmail]: 'Be sure to check your junk or spam folder.',
      [lblResetPasswordResetCta]: 'RESET PASSWORD',
      [lblResetPwdConfirmPwd]: 'Confirm New Password',
      [lblResetPassword]: 'New Password',
      [lblResetPwdResendCode]: 'Resend it.',
      [lblResetPwdSuccessMsg]: 'Your password has been updated and can be used for logging in!',
      [lblChangePwdHide]: 'Hide',
      [lblChangePwdShow]: 'Show',
      [lblResetPwdPageCheckCode]: 'Check the code that we sent to your email and try again.',
      [lblResetPwdPageCheckCodePhone]: 'Check the code that we sent to your phone and try again.',
      [lblResetPwdBackLogin]: 'Back to Log In',
      [lblResetPwdHeading]: 'Reset Your Password',
      [lblResetPwdOtpSentPhone]: 'Password reset sent to your phone number',
      [lblResetPwdEnterCode]: 'Verify one-time passcode',
      [lblCodeSubHeaderMsg]: 'Enter the secure code we just texted you.',
      [lblConfirmCodeMsg]: '',
      [lblChangePwdHeading]: 'CHANGE PASSWORD',
      [lblCurrentPwd]: 'Current Password',
      [lblEnterPwd]: 'Please Enter Password',
      [lblNewPwd]: 'New Password',
      [lblConfirmPwd]: 'Confirm New Password',
      [lblSaveCta]: 'CHANGE PASSWORD',
      [lblLoginCtaPlcc]: 'LOGIN',
      [lblSaveAndCheckoutCta]: 'SAVE PASSWORD & CHECKOUT',
      [lblSaveCtaPlcc]: 'SAVE PASSWORD & LOGIN',
      [lblInputSuccess]: 'Looks good!',
      [lblrequirementTip1]: 'At least 8 characters',
      [lblrequirementTip2]: '1 uppercase letter',
      [lblrequirementTip3]: '1 number',
      [lblrequirementTip4]: '1 special character: !@#$%^&*()?',
      [lblrequirementTip5]: '1 lowercase letter',
      [lblrequirementTip6]: 'No spaces',
      [lblRequirementHeading]: 'Password Requirements',
      [lblInvalidCurrentPwd]: 'Please check the password & try again',
      [lblPasswordInfo]:
        'Password must contain at least 8 characters, 1 lowercase letter, 1 uppercase letter, 1 number, 1 special character !@#$%^&*()? and no spaces. Note: It cannot be your email address or a recently used password. ',
      [lblResetPwdCheckRecaptcha]: 'ERROR: Please check the recaptcha value',
    },
  },
};
